<template>
  <div class="login-page">
    <meta name="referrer" content="no-referrer" />
    <div class="login-box">
      <div class="top">
        <span style="font-size: 26px; font-weight: bold; color: #000000; margin-left: 50px">{{ $t('应用编辑器') }}</span>

        <!-- <LanguageSwitcher style="position: absolute; top: 10px; right: 20px;" bordered /> -->
      </div>
      <div class="content">
        <div class="tabs-wrapper">
          <a-tabs :active-key="customActiveKey" @change="changeTab" :tab-bar-style="{ fontWeight: 'bold' }">
            <a-tab-pane key="1" :tab="$t('账号登录')">
              <a-form id="formLogin" class="user-layout-login" ref="formLogin" :form="form">
                <a-form-item>
                  <a-input
                    type="text"
                    size="large"
                    :placeholder="$t('请输入')"
                    v-decorator="[
                      'userName',
                      {
                        initialValue: '',
                        rules: [
                          { required: true, message: $t('请输入') }
                        ],
                        validateTrigger: 'change'
                      }
                    ]"
                    style="width: 400px"
                  >
                    <a-icon slot="prefix" type="user" />
                  </a-input>
                </a-form-item>

                <a-form-item>
                  <a-input
                    type="password"
                    size="large"
                    autocomplete="false"
                    :placeholder="$t('请输入')"
                    v-decorator="[
                      'password',
                      {
                        initialValue: '',
                        rules: [{ required: true, message: $t('请输入') }],
                        validateTrigger: 'blur'
                      }
                    ]"
                    style="width: 400px"
                  >
                    <a-icon slot="prefix" type="lock" />
                  </a-input>
                </a-form-item>
                <a-form-item style="margin-top: 10px;">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    class="login-button"
                    :loading="loading"
                    @click="handleLogin"
                  >
                    {{ $t('登录') }}
                  </a-button>
                </a-form-item>
              </a-form>
            </a-tab-pane>
            <!-- <a-tab-pane key="2" tab="统一身份认证" /> -->
          </a-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { mapActions } from 'vuex'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { sm4Encrypt } from '@/utils/sm4'

export default {
  components: {
    LanguageSwitcher,
  },
  data() {
    return {
      customActiveKey: '1',
      form: this.$form.createForm(this),
      loading: false,
    }
  },
  created() {

  },
  methods: {
    ...mapActions(['login', 'logout']),
    changeTab(tab) {
      this.customActiveKey = '1'
      if (tab === '1') {
        return
      }
      const appId = this.$route.query?.appId ?? '0'
      const currentUrl = window.location.href
      const baseUrl = currentUrl.split('#')[0]
      const callbackUrl = `${baseUrl}api/system/auth/cas/${tab === '2' ? 'hitCas' : 'hitszCas'}/${appId}`
      const url = tab === '2' ? `https://ids.hit.edu.cn/authserver/login?service=${encodeURIComponent(callbackUrl)}`
          : `https://sso.hitsz.edu.cn:7002/cas/login?service=${encodeURIComponent(callbackUrl)}`
      window.open(url, '_blank')
    },
    handleLogin() {
      const form = this.form
      form.validateFields((error, values) => {
        if (error) {
          return
        }
        this.loading = true
        const loginData = { appId: sm4Encrypt(this.$route.query.appId, 'smartheer-login!', 'smartheer-login#'), userName: sm4Encrypt(values.userName, 'smartheer-login!', 'smartheer-login#'), password: sm4Encrypt(md5(values.password), 'smartheer-login!', 'smartheer-login#')}
        this.logout().finally(() => {
          this.login(loginData).then(res => {
            if (res.code === 0) {
              setTimeout(() => {
                this.$router.push({ path: '/' })
              }, 100);
            } else {
              this.$message.error(res.message || this.$t('登录失败'))
            }
          }).finally(() => {
            this.loading = false
          })
        })
      })
    }
  }
}

</script>

<style lang="less" scoped>
@import '../../components/index.less';
@import "~@/components/theme.less";

.login-page {
  position: fixed;
  top: 0;
  background-image: url('/public/image/login/bg.png');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: @primary-color;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-box {
    width: 600px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(23, 77, 144, 0.5);
    border-radius: 10px;
    padding: 40px 40px 20px 30px;
    .top{
      position: relative;
      display: flex;
      align-items: center; /* 垂直居中 */
      //justify-content: center; /* 水平居中，如需要 */
      //height: 100px; /* 容器高度，根据需要设置 */
    }

    .content {
      display: flex;
      margin-top: 20px;
      justify-content: space-between;
      .tabs-wrapper {
        flex: 4;
        width: 360px;
        margin-left: 50px;
        ::v-deep .ant-tabs-bar {
          margin-bottom: 30px;
        }
        .ant-form {
          .ant-form-item {
            margin-bottom: 30px;
          }
          .forget-password {
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
            color: #162741;
            margin-bottom: 14px;
            float: right;
          }
          .login-button {
            width: 400px;
            height: 45px;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 600;
            background: @primary-color;
            border-color: @primary-color;
            color: #fff;
          }
        }
        .line-wrapper {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .text {
            padding: 0 8px;
          }
          .line {
            flex: 1;
            height: 1px;
            border-radius: 3px;
            border: 1px solid @primary-color-active;
          }
        }
        .other {
          .thirty-party {
            display: flex;
            justify-content: center;
            div {
              width: 60px;
              height: 60px;
              background: #ffffff;
              border-radius: 30px;
              border: 1px solid @primary-color-active;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              & + div {
                margin-left: 16px;
              }
            }
          }
        }
      }
    }

    .footer {
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      margin-top: 60px;
    }
  }
}

.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }
}
</style>
